import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import DatePicker from "./DatePicker";
import Scorecards from "./Scorecards";
import RiskMembersTable from "./RiskMembersTable";
import { DataPoints } from "./DataPoints";
import { actionCreators } from "../redux/RiskMembersSagas";

const ZeroVisitsView = () => {
  const dispatch = useDispatch();
  const {
    updatesLoading,
    scorecards,
    includeFutureVisits,
    table: { data = [] }
  } = useSelector((state) => state.riskMembers);

  return (
    <div>
      <div
        id="override-edit-selection-bar"
        className="dropdown dropdown-actions actions"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          marginBottom: 30
        }}
      >
        <div className="filters-wrapper" style={{ display: "flex" }}>
          {data.length ? (
            <div className="toggle-button-wrapper">
              <p>Include Members with Future Bookings</p>
              <ToggleableButton
                isActive={includeFutureVisits}
                onClick={(isActive) => dispatch(actionCreators.handleToggle(isActive))}
                title="risk-members-future-bookings"
                isRadio
              />
            </div>
          ) : null}
        </div>
        <DatePicker />
      </div>
      {updatesLoading ? <LoadingAnimation uiLoader /> : data.length ? <DataPoints /> : null}
      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : (
          <>
            {scorecards.length ? <Scorecards scorecards={scorecards} /> : null}
            <RiskMembersTable />
          </>
        )}
      </div>
    </div>
  );
};

export default ZeroVisitsView;
